<template>
    <div class="mian_page">
        <div class="desktop-element">
            <div class="page_news flex-col">
                <my-menu class="sticky-menu" :default-active-index="3"></my-menu>
                <div class="er_main" >
                    <news-detail :datalist="datalist" ></news-detail>
                </div>
                <ChpcFooter></ChpcFooter>
                <contact-float v-show="isVisible" @change="change" />
                <contact-dialog v-show="!isVisible" @showContact="showContact"></contact-dialog>
            </div>
        </div>
        <div class="mobile-element">
            <mobile-header class="sticky-menu-mobile" :default-active-index="3"></mobile-header>
            <div class="mobile-link">
                <mobile-link :default-active-index="3"></mobile-link>
                <mobile-detail :datalist="datalist"></mobile-detail>
            </div>
            <mobile-footer @contactMobile="contactMobile"></mobile-footer>
            <mobile-contact-dialog v-show="isVisibleMobile" @closeMobileContact="closeMobileContact"></mobile-contact-dialog>

        </div>
    </div>
</template>
<script>
    import myMenu from "@/views/Component/ChpcMenu.vue";
    import ChpcFooter from "@/views/Component/ChpcFooter";
    import ContactFloat from "@/views/Component/Contact.vue";
    import ContactDialog from "@/views/Component/ContactDialog";
    import newsDetail from "./childPage/newsDetail";
    //mobile
    import MobileHeader from "@/views/Component/MobileHeader";
    import MobileLink from "@/views/Component/MobileLink";
    import MobileFooter from "@/views/Component/MobileFooter";
    import MobileDetail from "./childPage/MobileDetail";
    import MobileContactDialog from "@/views/Component/MobileContactDialog";
    import MobileList from "./childPage/MobileList";

    export default {
        name: "newDetailIndex",
        metaInfo:{
            title:'北京康柏汉森医药科技咨询有限责任公司',
            meta:[{name: 'keyWords', content:'官网，CHPC，医药咨询，康柏汉森，医药科技咨询；医药企业营销咨询；企业管理咨询；商务咨询'},
                {name:'description', content:'简称CHPC, CHPC起步于医药行业,中国医药行业内风险控制领域的服务提供商，提供渠道核查、合规核查、信息技术、管理咨询服务'},
                {name:"robots",content:"官网，中国医药行业内风险控制领域的服务提供商"},
            ]
        },
        data() {
            return {
                isVisible:true,
                isVisibleMobile:false,
                datalist:[],
            };
        },
        //
        components:{
            myMenu,ChpcFooter,newsDetail,ContactDialog,ContactFloat,
            MobileHeader,MobileLink,MobileFooter,MobileDetail,MobileContactDialog
        },
        computed: {

        },
        mounted() {
            let newsId =  this.$route.query.id;
            if(newsId){
                this.getInfo(newsId);
            }

        },
        methods: {
            change(){
                this.isVisible = false;
            },
            showContact(){
                this.isVisible = true;
            },
            contactMobile(){
                this.isVisibleMobile = true;
            },
            closeMobileContact(){
                this.isVisibleMobile = false;
            },
            getInfo(id){
                //新闻中心
                let query ={code:'xwzx',id:id,pageSize:this.pageSize};
                this.$HTTP.getNewsDetail(query).then(resp => {
                    if(resp.code == 200){
                        let data = resp.data;
                        this.datalist =data;
                    }
                });
            },
        }
    };
</script>
<style scoped lang="css" src="./css/index.css" />
